/* eslint semi:0 */
import './jwplayerStyles.scss'
import { nodes, parentElementUntil } from '../../jsCore/utils/dom'
import { connect } from 'react-redux'
import { randId } from '../../jsCore/utils/string'
import { findDOMNode } from 'react-dom'
import React, { Component } from 'react'
import reduxMount from '../../jsCore/utils/reduxMounter'
import { queryString } from '../../jsCore/utils/window'
import * as jwplayerActions from './jwplayerActions'
import { withParentAttributesAsProps } from '../../jsCore/utils/reactUtils'
import { external as externalScriptLoader } from '../../jsCore/utils/script'
import { MOUNT_POINTS } from '../../jsCore/config/preRenderedSelectorsConfig'
import { Spinner } from '../../components/spinner/spinner'
import { externalScriptsConfig } from '../../jsCore/organizedByType/config/externalScripts'
import * as videoUtils from '../../jsCore/utils/video'
import {
  jwplayerReducer,
  isInitializedSelector,
  STATE_KEY,
  sdkLoadingStateSelector,
} from './jwplayerReducer'

import { ads as pageAdsConf } from '../../jsCore/application/pageDataObject'
import { AD_FORMATS } from '../../jsCore/organizedByType/config/adsConfig'
import { getVideoAdTargeting } from '../../jsCore/organizedByType/vms/ads/adTargeting'
import { getVideoAdServerUrl } from '../../jsCore/organizedByType/vms/ads/adTargeting'
import { getPro7VideoAdServerUrl } from '../../jsCore/organizedByType/vms/ads/adTargeting'
import publicPdo from '../../jsCore/application/pageDataObject'
import { makeSafeFn } from '../../jsCore/utils/fn'

class JwPlayerContainerComponent extends Component {
  constructor(props) {
    super(props)
    Object.assign(this, {
      id: `ID${randId()}`,
      initPlayer: this.initPlayer.bind(this),
      setupAnalytics: this.setupAnalytics.bind(this),
    })
  }

  componentWillMount() {
    const { isInitialized, sdkLoadingState, loadSdk, sdkLoaded } = this.props
    this.dataset = findDOMNode(this).parentNode.dataset
    if (!isInitialized && !sdkLoadingState) {
      loadSdk()
      const src = externalScriptsConfig.jwplayer.src(this.dataset.player_id)
      externalScriptLoader.load({
        config: {
          src,
          name: externalScriptsConfig.jwplayer.name,
        },
      })(sdkLoaded)
    }
  }

  initPlayer(playerRef) {
    const adsClient = 'googima'
    const player = window.jwplayer(findDOMNode(playerRef))
    const { video_id: mediaId, file_url: file, thumbnail: image } = this.dataset
    if (shouldSendJwTagServerUrl()) {
      player.setup({
        file,
        image,
        mediaId,
        advertising: {
          autoplayadsmuted: true,
          client: adsClient,
          schedule: {
            preroll: {
              custParams: getVideoAdTargeting(
                getOwnCustomCriteria(this.props.options.dataset.player_id)
              ),
            },
          },
        },
      })
      this.setupAnalytics(player, mediaId)
      player.on('firstFrame', _ => player.playAd(tag()))
    } else {
      //EI double click ads tags managed from jwplayer therfore we have 2 diffrent setup
      player.setup({
        file,
        image,
        mediaId,
      })
    }
  }

  getVideoPostWrapperName(playerRef) {
    const analyticsWrappersDescription = {
      'post-cover': 'cover',
      'post-body-wrap': 'body',
    }

    const articleSectionVideoWrapper = parentElementUntil(ancestorWrapper => {
      return (
        ancestorWrapper.classList.contains('post-cover') ||
        ancestorWrapper.classList.contains('post-body-wrap')
      )
    })

    const postAncestorNode = articleSectionVideoWrapper(playerRef)
    let wrapperName = 'no wrapper'

    return !postAncestorNode
      ? wrapperName
      : Object.keys(analyticsWrappersDescription).reduce((acc, currentValue) => {
          return postAncestorNode.classList.contains(currentValue)
            ? analyticsWrappersDescription[currentValue]
            : acc
        }, wrapperName)
  }

  analyticsTrackTimePercent(jwTimeAnalyticsAction) {
    let lastPercentageStep = -1

    return function calculateVideoTimePercent(time) {
      const computedVideoStepPercentage = videoUtils.calculateVideoTimePercent(
        time.duration,
        time.position
      )

      if (
        computedVideoStepPercentage.constructor === Number &&
        lastPercentageStep !== computedVideoStepPercentage
      ) {
        jwTimeAnalyticsAction(time, computedVideoStepPercentage)

        lastPercentageStep = computedVideoStepPercentage
      }
    }
  }

  analyticsEvent(jwAnalyticsAction) {
    return function addTimeStampToAnalyticsEvent(evt) {
      const duration = this.getDuration()
      const position = this.getPosition()

      jwAnalyticsAction(duration, position)
    }
  }

  setupAnalytics(player, videoId) {
    const videoMainWrapperName = this.getVideoPostWrapperName(player.getContainer())
    const pageType = videoUtils.getAnalyticsPageType()
    const { props } = this
    const args = [null, videoId, pageType, videoMainWrapperName]

    player.on('play', this.analyticsEvent(props.jwplayerAnalyticsPlayAction.bind(...args)))
    player.on(
      'time',
      this.analyticsTrackTimePercent(props.jwplayerAnalyticsPercentageChangeAction.bind(...args))
    )
    player.on('complete', this.analyticsEvent(props.jwplayerAnalyticsCompleteAction.bind(...args)))
    player.on('pause', this.analyticsEvent(props.jwplayerAnalyticsPauseAction.bind(...args)))
  }

  render() {
    const isJwInitalized = this.props.isInitialized
    return isJwInitalized ? (
      <div id={this.id} ref={this.initPlayer} />
    ) : (
      <Spinner isInitialized={isJwInitalized} contrastModifier={this.dataset.contrast} />
    )
  }
}

const COMPONENT_NAME = 'jwplayerContainer'

function shouldSendJwTagServerUrl() {
  return publicPdo.ads.property != 'EI'
}

function mapStateToProps(state) {
  return {
    isInitialized: isInitializedSelector(state),
    sdkLoadingState: sdkLoadingStateSelector(state),
  }
}

const jwPlayerContainer = {
  name: COMPONENT_NAME,
  stateKey: STATE_KEY,
  component: connect(mapStateToProps, jwplayerActions)(
    withParentAttributesAsProps(JwPlayerContainerComponent)
  ),
  reducer: jwplayerReducer,
}

function shouldMountJwPlayer() {
  return nodes(MOUNT_POINTS.JWPLAYER_BODY).length !== 0
}

function getOwnCustomCriteria(playerId) {
  return new Map([['format', AD_FORMATS.Vcover], ['playerId', playerId]])
}

function tag() {
  return publicPdo.ads.isProSeven
    ? makeSafeFn(getPro7VideoAdServerUrl).invoke()
    : getVideoAdServerUrl()
}
export default function initJwPlayers() {
  if (!shouldMountJwPlayer()) {
    return false
  }
  return reduxMount({
    [MOUNT_POINTS.JWPLAYER_BODY]: jwPlayerContainer,
  })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/jwplayer/jwplayerContainer.js